export function getPreviousAddress(previousAddress) {
    var unitPart = previousAddress.unit ? ", Unit ".concat(previousAddress.unit) : '';
    return "".concat(previousAddress.street).concat(unitPart, ", ").concat(previousAddress.city, ", ").concat(previousAddress.state, ", ").concat(previousAddress.zipCode, "\n").concat(previousAddress.name || '', ", ").concat(previousAddress.phone ||
        '', "\n").concat(previousAddress.instructions || '');
}
//# sourceMappingURL=getPreviousAddress.js.map